import React from 'react';
import { Card, Typography } from '@material-ui/core';
import { GQLSide, GQLSymbol, GQLSymbolEngraving } from '@jewelutions/core-crm-server-api-client-domain';
import { Box } from '../../types-hack';

interface IProps {
  side: GQLSide;
  engraving: GQLSymbolEngraving;
  symbol: GQLSymbol;
}

const EngravingSymbolDetails: React.FC<IProps> = ({ side, engraving, symbol }: IProps) => {
  return (
    <Card style={{ width: 'fit-content' }}>
      <Box p={5}>
        <Typography variant={'h6'}>
          Symbol engraving : {symbol.title.en} & Scaling :
          {engraving.scalingFactor !== -1 ? engraving.scalingFactor : 'MAX'}
        </Typography>
        <Typography variant={'h6'}>Side : {side}</Typography>
      </Box>
    </Card>
  );
};

export default EngravingSymbolDetails;
